{
  "source": "FIFA/Coca-Cola Men's World Ranking — mise à jour officielle du 11 juin 2026, en vigueur au coup d'envoi de la CdM 2026 (figée pour le tournoi). Dernier critère de départage CdM 2026 (art. 13) avant le tirage au sort.",
  "asOf": "2026-06-11",
  "note": "Position mondiale par code équipe (1 = meilleur). Couvre les équipes du top 60 présentes dans le tournoi ; toute équipe absente retombe sur l'Elo (proxy) au départage.",
  "ranks": {
    "ARG": 1,
    "ESP": 2,
    "FRA": 3,
    "ENG": 4,
    "POR": 5,
    "BRA": 6,
    "MAR": 7,
    "NED": 8,
    "BEL": 9,
    "GER": 10,
    "CRO": 11,
    "COL": 13,
    "MEX": 14,
    "SEN": 15,
    "URU": 16,
    "USA": 17,
    "JPN": 18,
    "SUI": 19,
    "IRN": 20,
    "TUR": 22,
    "ECU": 23,
    "AUT": 24,
    "KOR": 25,
    "AUS": 27,
    "ALG": 28,
    "EGY": 29,
    "CAN": 30,
    "NOR": 31,
    "CIV": 33,
    "PAN": 34,
    "SWE": 38,
    "CZE": 40,
    "PAR": 41,
    "SCO": 42,
    "TUN": 45,
    "COD": 46,
    "UZB": 50,
    "QAT": 56,
    "IRQ": 57,
    "RSA": 60
  }
}
